import { createStore } from 'vuex'

export default createStore({
  state: {
    loginStatus: false,
    token: '',
    userInfo: {
      // createTime: "2024-01-08 17:04:43"
      // creatorId: null
      // creatorName: ""
      // id: 4
      // isEnabled: 1
      // phone: "17767746248"
      // realName: ""
      // score: null
      // sex: ""
      // updateTime: "2024-01-08 17:04:43"
      // userName: "1020363151@qq.com"
    },
    // avatar: '',
    gameToPlayIdx: null,
    gameRuleList: [
      // {
      // createTime: "2024-01-03 09:47:25",
      // creatorId: null,
      // creatorName: "",
      // description: "完成任一环节（浇水，施肥，除虫，修剪）可得分",
      // id: 3,
      // name: "一起来植树",
      // rtf: "<p>123</p><p>321</p>",
      // score: 101,
      // second: null,
      // second: 60,
      // type: "game",
      // updateTime: "2024-01-08 19:28:35",
      // },
    ],
    isDirectPlayGame: false,
    score: undefined,
    scoreResetDateMs: undefined,
    ifScoreLimitReached: undefined,
    scoreLimit: undefined,
  },
  getters: {
  },
  mutations: {
    setLoginStatus(state, value) {
      state.loginStatus = value
    },
    setToken(state, value) {
      state.token = value
      localStorage.setItem('token', value)
    },
    setUserInfo(state, value) {
      state.userInfo = value
      localStorage.setItem('userInfo', JSON.stringify(value))
      if (state.userInfo.score === null) {
        state.userInfo.score = 0
      }
    },
    logoutCallback(state) {
      state.loginStatus = false
      state.token = ''
      localStorage.removeItem('token')
      state.userInfo = {}
      localStorage.removeItem('userInfo')
    },
    changeBonusPoint(state, delta) {
      state.avatar += delta
    },
    setGameToPlayIdx(state, index) {
      state.gameToPlayIdx = index
    },
    setGameRuleList(state, value) {
      state.gameRuleList = value
    },
    setScore(state, value) {
      state.score = value
    },
    setScoreResetDateMs(state, value) {
      state.scoreResetDateMs = value
    },
    setIfScoreLimitReached(state, value) {
      state.ifScoreLimitReached = value
    },
    setScoreLimit(state, value) {
      state.scoreLimit = value
    },
    setIsDirectPlayGame(state, value) {
      state.isDirectPlayGame = value
    },
  },
  actions: {
  },
  modules: {
  }
})